export const PointRange = 8;
export const MinPoint = 0;
export const MaxPoint = 5;
export const PointArray = [
  {
    id: 0,
    title: "근육발달/선명도",
    startPoint: 1,
    endPoint: MaxPoint,
    rangeLength: MaxPoint,
  },
  {
    id: 1,
    title: "신체대칭/균형",
    startPoint: 1,
    endPoint: MaxPoint,
    rangeLength: MaxPoint,
  },
  {
    id: 2,
    title: "무대포즈와 표현",
    startPoint: 1,
    endPoint: MaxPoint,
    rangeLength: MaxPoint,
  },
  {
    id: 3,
    title: "규정준수",
    startPoint: 1,
    endPoint: MaxPoint,
    rangeLength: MaxPoint,
  },
  {
    id: 4,
    title: "의상/스타일",
    startPoint: 1,
    endPoint: MaxPoint,
    rangeLength: MaxPoint,
  },
  {
    id: 5,
    title: "비교평가",
    startPoint: 0,
    endPoint: MaxPoint,
    rangeLength: MaxPoint + 1,
  },
];
